import { render } from "./UserProfile.vue?vue&type=template&id=49f71f71"
const script = {}

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__